import { render } from "./askde.vue?vue&type=template&id=39a0040a&scoped=true"
import script from "./askde.vue?vue&type=script&lang=js"
export * from "./askde.vue?vue&type=script&lang=js"

import "./askde.vue?vue&type=style&index=0&id=39a0040a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1941686567/src/amplify-vue-poc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39a0040a"]])

export default __exports__